import { SET_IS_LOADED } from '../actions/set-is-loaded';
import { FETCH_COMMENTS_SUCCESS, FETCH_COMMENTS_FAILURE } from '../actions/fetch-comments';
import { FETCH_POSTS_SUCCESS, FETCH_POSTS_FAILURE } from '../actions/fetch-posts';
import { FETCH_USER_POSTS_SUCCESS, FETCH_USER_POSTS_FAILURE } from '../actions/fetch-posts-by-owner-id';
import { FETCH_NOTIFICATIONS_SUCCESS, FETCH_NOTIFICATIONS_FAILURE } from '../actions/fetch-notifications';
import { FETCH_POST_SUCCESS, FETCH_POST_FAILURE } from '../actions/fetch-post';

export default function isLoaded(state = {}, action) {
  switch (action.type) {
    case SET_IS_LOADED:
      return setIsLoaded(state, action.payload);

    case FETCH_USER_POSTS_SUCCESS:
    case FETCH_USER_POSTS_FAILURE:
      return setIsLoaded(state, {
        entity: 'profile-posts',
        id: action.payload.ownerId,
        isLoaded: true,
      });

    case FETCH_POST_SUCCESS:
    case FETCH_POST_FAILURE:
      return setIsLoaded(state, {
        entity: 'post',
        id: action.payload.postSlug,
        isLoaded: true,
      });

    case FETCH_POSTS_SUCCESS:
    case FETCH_POSTS_FAILURE:
      return setIsLoaded(state, {
        entity: 'posts',
        id: action.meta.categoryId,
        isLoaded: true,
      });

    case FETCH_COMMENTS_SUCCESS:
    case FETCH_COMMENTS_FAILURE:
      return setIsLoaded(state, {
        entity: 'comments',
        id: action.payload.postSlug,
        isLoaded: true,
      });

    case FETCH_NOTIFICATIONS_SUCCESS:
    case FETCH_NOTIFICATIONS_FAILURE:
      return setIsLoaded(state, {
        entity: 'notifications',
        isLoaded: true,
      });

    default:
      return state;
  }
}

function setIsLoaded(state, { entity, id = '', isLoaded }) {
  return {
    ...state,
    [entity]: {
      ...state[entity],
      [id]: isLoaded,
    },
  };
}



// WEBPACK FOOTER //
// ./app/reducers/is-loaded.js